<!--农村公路自动化检测服务-->
<template>
    <div class="system-container">
        <div class="section">
            <div class="section-content">
                <div class="title">自动化检测概述</div>
                <p class="text">
                    根据交通运输部和财政部《关于进一步加强农村公路技术状况检测评定工作的通知》( 交办公路 [2021]83 号 ) 要求，
                    至 2022 年农村公路路面自动化检测比例达到 40% 以上 ; 至 2025 年基本实现具备检测条件的农村公路路面自动化检
                    测全覆盖。我司为更好地服务农村公路路况自动化检测评定工作，采用多功能路面检测设备，均能满足国家《多功能路况快
                    速检测设备》和《公路技术状况评定标准》《低等级农村公路技术状况评定指南》等行业标准、规范要求。确保了检测设备
                    能够有效计量溯源，提供稳定、可靠、准确的检测指标数据，有效体现真实路况质量，为养护工程科学决策提供有力数据支持。
                </p>
                <div class="core-panel">
                    <div class="panel" v-for="(item,index) in funcList" :key="index">
                        <div class="header" :style="{backgroundImage:`url(${item.bg})`}">
                            <img class="img" :src="item.icon" alt="">
                        </div>
                        <!--移动端适配-->
                        <div class="mobile-header" :style="{backgroundImage:`url(${item.bg})`}">
                            <img class="img" :src="item.icon" alt="">
                        </div>
                        <div class="content">
                            <div class="label">{{ item.label }}</div>
                            <div class="tag">{{ item.tag }}</div>
                            <div class="line"></div>
                            <div class="p">{{ item.text }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section bg">
            <div class="section-content">
                <div class="title">检测方式</div>
                <p class="text">
                    采用“自动化采集 + 人工 APP 采集”检测模式，技术等级三级及以上或具备条件的四级公路采用自动化检测，
                    砂石路段和自动化检测受限的农村公路采用人工 APP 检测，对路面（PQI）、路基（SCI）及沿线设施（TCI）
                    技术状况指数进行系统评定，确保了检测数据的统一性，提高了检测效率，加强了检测精准度，提升了自动化检
                    测比例。
                </p>
                <img class="image" src="@/assets/image/prescription/jcfs_bg.png" alt="">
                <!--移动端适配-->
                <img class="mobile-image" src="@/assets/image/prescription/jcfs_bg.png" alt="">
            </div>
        </div>
        <div class="section">
            <div class="section-content">
                <div class="title">检测提交成果</div>
                <div class="img-content">
                    <div class="frame">
                        <img src="@/assets/image/prescription/report.png" style="height: 100%;width: 100%;" alt="">
                    </div>
                    <div class="table">
                        <div class="table1">
                            <img class="table_image" src="@/assets/image/prescription/table_1.png" alt="">
                        </div>
                        <div class="table1">
                            <img class="table_image" src="@/assets/image/prescription/table_2.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section" style="background-color: #EAF3FF">
            <div class="section-content">
                <div class="title">成果应用价值</div>
                <div class="panel-content">
                    <div class="panel" v-for="(item,index) in panelList" :key="index">
                        <img class="img" :src="item.icon" alt=""/>
                        <div class="content">
                            <div class="label">{{ item.label }}</div>
                            <p class="article">
                                {{ item.text }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-content">
                <div class="title">检测案例</div>
                <Carousel type="card" height="300px" class="carousel" :images="imageList"/>
                <el-carousel class="mobile-carousel" height="200px" trigger="click" type="card">
                    <el-carousel-item v-for="(item,index) in imageList" :key="index">
                        <img
                            :src="item"
                            style="width: 100%;height: 100%;
                            object-fit: scale-down"
                            alt
                        />
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>

<script>
//components
import Carousel from "@/components/Carousel";

export default {
    components: {
        Carousel
    },
    name: "ruralRoadAutoDetection",
    data() {
        return {
            funcList: [
                {
                    bg: require('@/assets/image/prescription/func_bg5.png'),
                    icon: require('@/assets/image/prescription/icon_35.png'),
                    label: '16+ 个',
                    tag: '自动化检测省份',
                    text: '截止目前我司公路技术状况检测已覆盖全国16个省份108个县区'
                },
                {
                    bg: require('@/assets/image/prescription/func_bg6.png'),
                    icon: require('@/assets/image/prescription/icon_36.png'),
                    label: '22万+ 公里',
                    tag: '自动化检测里程',
                    text: '截止目前自动化检测总里程达22万公里，自主研发的“建管养运”大数据云平台，先后在多个省、市、县得到广泛应用'
                },
                {
                    bg: require('@/assets/image/prescription/func_bg7.png'),
                    icon: require('@/assets/image/prescription/icon_37.png'),
                    label: '62+ 家',
                    tag: '示范县咨询服务',
                    text: '为62家交通事业单位成功荣获国家级、省级四好农村公路示范县，相关成果得到客户高度评价'
                }
            ],
            panelList: [
                {
                    icon: require("@/assets/image/prescription/icon_38.png"),
                    label: '开展定期检测，为道路安全运行提供保障',
                    text: '通过开展自动化检测，对路基、路面、桥涵构造物、沿线设施健 康状况定期检测，及时养护维修，有效延长设施生命周期，消除 安全隐患。'
                },
                {
                    icon: require("@/assets/image/prescription/icon_39.png"),
                    label: '基础数据更新，为规划建设提供准确数据 ',
                    text: `依托农村公路路况检测，在全域范围内对纳入统计年报的农村公路进行专项调 查，对全域农村公路基础数据、
                    地理位置、线位走向、通达情况、基本状况等进行了 清洗普查 , 全面梳理全域农村公路基础设施数据。`
                },
                {
                    icon: require("@/assets/image/prescription/icon_40.png"),
                    label: '依据定检数据，为养护工程编制提供科学依据 ',
                    text: `通过路面自动化检测全面准确的掌握了全域农村公路技术状况水平，有利于科学编制农村公路养护工程计划，有效
                    提高养护工程实施的精准度，提升了养护决策科学化水平。`
                },
            ],
            imageList: [
                require('@/assets/image/prescription/case_1.jpg'),
                require('@/assets/image/prescription/case_2.jpg'),
                require('@/assets/image/prescription/case_3.jpg'),
                require('@/assets/image/prescription/case_4.jpg'),
            ]
        }
    },
    mounted() {
    },
    methods: {}
}
</script>


<style scoped lang="scss">
.system-container {
    height: 100%;
    width: 100%;

    .bg {
        background-image: url('~@/assets/image/prescription/xtjs_bg.png');
    }

    .section {
        height: 100%;
        width: 100%;

        .section-content {
            margin: 0 auto;
            width: 1200px;
            padding: 50px 0;

            .title {
                text-align: center;
                font-size: 32px;
            }

            .text {
                margin-top: 40px;
                text-indent: 2em;
                line-height: 32px;
                text-align: justify;
                font-size: 20px;
            }

            .image {
                margin-top: 60px;
                width: 100%;
            }

            .mobile-image{
                display: none;
            }
        }

        .core-panel {
            margin-top: 60px;
            display: flex;
            justify-content: space-between;


            .panel {
                $width: 48px;
                width: calc(33% - 32px);
                transition: all .3s ease-in-out;

                &:hover {
                    box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);

                    .content {
                        .line {
                            width: $width * 2;
                        }
                    }
                }


                .header {
                    background-size: 100% 100%;
                    height: 200px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;

                    .img {
                        height: 72px;
                        width: 72px;
                        margin-top: auto;
                        transform: translateY(50%);
                    }
                }

                .mobile-header {
                    display: none;
                }

                .content {
                    box-sizing: border-box;
                    height: 300px;
                    border: 1px solid #DCDCDC;
                    border-top: none;
                    padding: 40px 40px 30px 40px;

                    .label {
                        font-size: 30px;
                        color: #0079FE;
                    }

                    .tag {
                        margin-top: 12px;
                        font-size: 20px;
                    }

                    .line {
                        margin-top: 24px;
                        width: $width;
                        border: 1px solid #0079FE;
                        transition: all .3s ease-in-out;
                    }

                    .p {
                        margin-top: 24px;
                        font-size: 20px;
                        line-height: 32px;
                        text-align: justify;
                    }
                }


            }
        }

        .img-content {
            margin-top: 80px;
            height: 517px;
            display: flex;
            justify-content: space-between;

            .frame {
                box-sizing: border-box;
                height: 100%;
                width: 378px;
                padding: 25px;
                background-image: url("~@/assets/image/prescription/frame.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }

            .table {
                width: calc(100% - 400px);
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .table1 {
                    width: 100%;
                    height: calc(100% / 2 - 16px);
                    border: 2px solid #E5E5E5;
                    border-radius: 4px;

                    .table_image {
                        height: 100%;
                        width: 100%;
                        object-fit: fill;
                    }
                }

            }
        }

        .panel-content {
            margin-top: 80px;

            .panel {
                padding: 30px;
                border-radius: 4px;
                box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);
                margin-bottom: 30px;
                display: flex;

                .img {
                    width: 100px;
                    height: 100px;
                }

                .content {
                    padding-left: 30px;

                    .label {
                        font-size: 24px;
                        font-weight: bold;
                        color: #333333;
                        padding: 8px 0;
                    }

                    .article {
                        margin-top: 16px;
                        text-align: justify;
                        line-height: 30px;
                        font-size: 20px;
                    }
                }
            }
        }

        .mobile-carousel {
            display: none;
        }
    }
}

@import "./style.scss";
</style>
